import { createAsyncThunk } from '@reduxjs/toolkit';
import { ResponseErrorWithHandled, ResponseSuccess } from '../../shared/types';
import {
  getTaskStatusCount,
  getTaskerData,
  getTasks,
  updateTasks,
  updateTaskNote,
  bulkTaskUpdate,
  getShareableTaskerData,
  getUndoTasks,
  getWhatsappLink,
  createTask,
} from './helper/tasks.api';
import { getFailedLinkedInTasks } from '../linkedin-automation/helpers/linkedin-automation.api';
import {
  GetTaskerParams,
  GetTasksParams,
  UpdateTask,
  UpdateTaskNoteRequest,
  GetShareableTaskerParams,
} from './utils/types';

export const getTasksRequest = createAsyncThunk<
  ResponseSuccess,
  GetTasksParams,
  { rejectValue: ResponseErrorWithHandled }
>('contact/getTasksRequest', async (args, thunkAPI) => {
  try {
    return await getTasks(args);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const getTaskStatusCountRequest = createAsyncThunk<
  ResponseSuccess,
  GetTasksParams,
  { rejectValue: ResponseErrorWithHandled }
>('contact/getTaskStatusCountRequest', async (args, thunkAPI) => {
  try {
    return await getTaskStatusCount(args);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const updateTasksRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateTask,
  { rejectValue: ResponseErrorWithHandled }
>('contact/updateTaskRequest', async (args, thunkAPI) => {
  try {
    return await updateTasks(args);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const getTaskerDataRequest = createAsyncThunk<
  ResponseSuccess,
  GetTaskerParams,
  { rejectValue: ResponseErrorWithHandled }
>('contact/getTaskerDataRequest', async (args, thunkAPI) => {
  try {
    return await getTaskerData(args);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const getShareableTaskerDataRequest = createAsyncThunk<
  ResponseSuccess,
  GetShareableTaskerParams,
  { rejectValue: ResponseErrorWithHandled }
>('contact/getShareableTaskerDataRequest', async (args, thunkAPI) => {
  try {
    return await getShareableTaskerData(args.hashId);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const updateTaskNoteRequest = createAsyncThunk<
  ResponseSuccess,
  UpdateTaskNoteRequest,
  { rejectValue: ResponseErrorWithHandled }
>('contact/updateTaskNoteRequest', async (args, thunkAPI) => {
  try {
    return await updateTaskNote(args);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const bulkTasksUpdateRequest = createAsyncThunk<
  ResponseSuccess,
  any,
  { rejectValue: ResponseErrorWithHandled }
>('tasks/bulk-task-update', async (payload, thunkAPI) => {
  try {
    return await bulkTaskUpdate(payload);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const getUndoTasksRequest = createAsyncThunk<
  ResponseSuccess,
  { params: GetTasksParams; taskId: number },
  { rejectValue: ResponseErrorWithHandled }
>('tasks/getUndoTasksRequest', async ({ params, taskId }, thunkAPI) => {
  try {
    return await getUndoTasks(params, taskId);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const getWhatsappLinkRequest = createAsyncThunk<
  ResponseSuccess,
  number,
  { rejectValue: ResponseErrorWithHandled }
>('tasks/getWhatsappLinkRequest', async (taskId, thunkAPI) => {
  try {
    return await getWhatsappLink(taskId);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const createTaskRequest = createAsyncThunk<
  ResponseSuccess,
  any,
  { rejectValue: ResponseErrorWithHandled }
>('tasks/createTaskRequest', async (payload, thunkAPI) => {
  try {
    return await createTask(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const getFailedTasksRequest = createAsyncThunk<
  ResponseSuccess,
  { page?: number; limit?: number },
  { rejectValue: ResponseErrorWithHandled }
>('contact/getFailedTasksRequest', async (args, thunkAPI) => {
  try {
    const result = await getFailedLinkedInTasks(args);
    return { payload: result, message: 'Success' };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});
